import { useDateLocale, useTimeZone } from '../../../../../hooks'
import { useCalendarGridContext } from '../../../CalendarGrid.hooks'
import { CalendarGridDayPopoverRow } from '../../../CalendarGridDayPopover'

import * as styles from './CalendarGridAgendaRow.module.css'

function CalendarGridAgendaRow({ item, onClickItem, onClickSecondaryLabel }) {
  const locale = useDateLocale()
  const timezone = useTimeZone()

  const { ItemRow } = useCalendarGridContext()

  const Row = ItemRow ?? CalendarGridDayPopoverRow

  return (
    <div className={styles.CalendarGridAgendaRow}>
      <Row
        isTimeInline
        item={item}
        locale={locale}
        timezone={timezone}
        onClickItem={onClickItem}
        onClickSecondaryLabel={onClickSecondaryLabel}
      />
    </div>
  )
}

export default CalendarGridAgendaRow
